import React from 'react';

const ContainerTitle = ({ title }) => {
  return <div className="w-fit font-header1 flex justify-start text-xs sm:text-sm md:text-xl">{title}</div>;
};

export default ContainerTitle;
